const subjectKey = (opportunity)=>opportunity.subjectId == null ? "label:".concat(opportunity.subject) : "id:".concat(opportunity.subjectId);
export const opportunityIdentity = (opportunity)=>JSON.stringify([
        opportunity.kind,
        opportunity.clientId,
        opportunity.relationshipId,
        subjectKey(opportunity)
    ]);
